import Vue from 'vue'
import VueGtm from 'vue-gtm'

/**
 * Initializes GTM for tracking.
 */
export const initializeGtm = () => {
  Vue.use(VueGtm, {
    enabled: true
    // debug: process.env.NODE_ENV !== 'production'
  })
}



// WEBPACK FOOTER //
// ./src/utils/gtm.js